module.exports = __webpack_public_path__ + "static/media/20ECE25.0e59cab3.jpg";